module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introductory"
    }
  }, [_vm._v("Introductory")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_vm._v("I")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_vm._v("The Cocktail Party")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_vm._v("II")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_vm._v("Hors-d’œuvre, First-course Dishes, and After-dinner Savouries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_vm._v("III")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_vm._v("Kitchen Knowledge")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#h1.1"
    }
  }, [_vm._v("Tables of Weights and Measures")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04"
    }
  }, [_vm._v("IV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04"
    }
  }, [_vm._v("Kitchen Processes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05"
    }
  }, [_vm._v("V")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05"
    }
  }, [_vm._v("Soups and Soup-making")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sauces")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Root Vegetables")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Vegetables")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetables: Flowers and Fruits")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Entrées, Dressed Vegetables, and Simple Luncheon Dishes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggs and Savoury Soufflés")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salads")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice, Risottos, Pilaffs, and Curries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastas, Pasta Dishes, and Batters")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meat – Beef, Mutton and Lamb, Pork, Veal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meat – Les Abats")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pièces Froides")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poultry and Game")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Force-meats, Farces, Stuffings, etc.")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Réchauffés")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devils, Barbecues, and Marinades")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Savoury Mousses, Soufflés, and Aspic")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk and Cheese")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread and Bread-making")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cakes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastry")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pâtisserie, Petits Fours, Petits Gâteaux, and Gros Gâteaux")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweets, Hot and Cold")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winkfield")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast and Tea")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garniture and Presentation of Food")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXIV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Menus, Parties, and Food for Special Occasions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Store Cupboard")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXVI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kitchen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXVII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modern Kitchen Appliances")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Wines, their Choice and Serving")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("International Conversion Tables")])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 63
// module chunks = 0